export default __webpack_public_path__ + "static/media/basic-auth.2dea4acf.png";